import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { createEFPic } from '@/utils/useEFPic';
import CommonButton from '@/components/EcoCreditsDay/CommonButton';
import gtm from '@/utils/gtm';
import { signupCookie } from '@/utils/cookies/signupCookie';

const { EFPic } = createEFPic('/media/ecocredits-day/pc/');

export default function RegisterBox() {
    const { t } = useLang('ecocreditsday.registerBox');
    const { locale } = useRouter();

    return (
        <div className={styles.registerBox}>
            <div className="register-box">
                <EFPic className="logo-svg" name={['register_icon.webp', 'register_icon.png']} />
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')}</div>
                <div
                    className="register-btn"
                    onClick={() => {
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'ecocredits_button',
                            type: 'Register',
                            list_name: t('title'),
                            button_name: t('btn_text'),
                        });
                        const redirect = ['us', 'ca'].includes(locale as string)
                            ? `https://www.ecoflow.com/${locale}/my`
                            : `https://www.ecoflow.com/${locale}/ecocredits-day`;
                        signupCookie?.({
                            sector_name: t('title'),
                            entry_position: 6,
                        });
                        window.open(`https://www.ecoflow.com/${locale}/register?redirect=${redirect}`);
                    }}
                >
                    <CommonButton disabledAni padding="9px 40px" lineHeight="25px" borderRadius="8px" bgColor="#111">
                        <div className="register-text">{t('btn_text')}</div>
                    </CommonButton>
                </div>
                <div className="login-box">
                    {t.rich('login_text', {
                        line1: (text: string[]) => (
                            <span
                                className="go-login"
                                onClick={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'ecocredits_button',
                                        type: 'Login',
                                        list_name: t('title'),
                                        button_name: t('gtm_btn_name'),
                                    });
                                    const redirect = ['us', 'ca'].includes(locale as string)
                                        ? `https://www.ecoflow.com/${locale}/my`
                                        : `https://www.ecoflow.com/${locale}/ecocredits-day`;
                                    signupCookie?.({
                                        sector_name: t('title'),
                                        entry_position: 5,
                                    });
                                    window.open(`https://www.ecoflow.com/${locale}/login?redirect=${redirect}`);
                                }}
                            >
                                {text}
                            </span>
                        ),
                    })}
                </div>
            </div>
        </div>
    );
}
